// GarminLogo (2026-10-18) — the single Garmin brand element for every Garmin surface (onboarding, Profile connections,
// Home training sources, activity source labels, the Garmin connection card).
// With an APPROVED official asset (config/brandAssets.js) it renders that file unmodified — light and dark variants
// via prefers-color-scheme. Without one it renders a neutral text tile with the word "Garmin": no drawn / recreated
// mark, no partnership claim. Always accessible: role="img" + aria-label (or decorative when a visible name is next
// to it).
import React from 'react';
import { Watch } from '@phosphor-icons/react';
import { GARMIN_BRAND } from '../../config/brandAssets';

export default function GarminLogo({ size = 44, variant = 'tile', decorative = false, brand = GARMIN_BRAND, className = '' }) {
  const label = decorative ? undefined : 'Garmin';
  const a11y = decorative ? { 'aria-hidden': 'true' } : { role: 'img', 'aria-label': label };

  if (brand && brand.approved && (brand.light || brand.dark)) {
    const light = brand.light || brand.dark;
    const dark = brand.dark || brand.light;
    const box = variant === 'inline' ? { height: size } : { width: size, height: size };
    return (
      <picture data-testid="garmin-logo" data-garmin-asset="official" className={`shrink-0 ${className}`} {...a11y}>
        <source srcSet={dark} media="(prefers-color-scheme: dark)" />
        <img src={light} alt={decorative ? '' : 'Garmin'} style={box} className="object-contain" />
      </picture>
    );
  }

  if (variant === 'inline') {
    return (
      <bdi dir="ltr" data-testid="garmin-logo" data-garmin-asset="text" {...a11y}
           className={`font-bold text-text ${className}`} style={{ fontSize: size }}>
        Garmin
      </bdi>
    );
  }
  // Decorative tile next to a visible "Garmin" name (Strava removal C2, 2026-10-21): a neutral watch icon, so the word
  // "Garmin" is shown ONCE (the name), never twice. A generic icon from the app's icon set — not a Garmin mark.
  if (decorative) {
    return (
      <span data-testid="garmin-logo" data-garmin-asset="icon" {...a11y} style={{ width: size, height: size }}
            className={`rounded-control bg-surface-2 border border-border text-text-muted flex items-center justify-center
                        shrink-0 ${className}`}>
        <Watch size={Math.round(size * 0.55)} weight="bold" aria-hidden="true" />
      </span>
    );
  }
  const fontSize = Math.max(9, Math.round(size * 0.27));
  return (
    <span data-testid="garmin-logo" data-garmin-asset="text" {...a11y} dir="ltr"
          style={{ width: size, height: size, fontSize }}
          className={`rounded-control bg-surface-2 border border-border text-text font-bold flex items-center
                      justify-center shrink-0 tracking-tight ${className}`}>
      Garmin
    </span>
  );
}
